if (!customElements.get('product-card-media-slider')) {
  customElements.define(
    'product-card-media-slider',
    class ProductCardMediaSlider extends HTMLElement {
      connectedCallback() {
        this.sliderEl = this.querySelector('[data-pcard-media-slider]');
        if (!this.sliderEl) return;

        const wrapper = this.sliderEl.querySelector('.swiper-wrapper');
        const slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];
        if (!slides || slides.length < 2) return;

        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          threshold: 2,
          initialSlide: 0,
          navigation: {
            nextEl: this.querySelector('.pcard-media-button-next'),
            prevEl: this.querySelector('.pcard-media-button-prev'),
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.sliderEl, this.sliderOptions);
        this.sliderInstance.init();
      }
    }
  );
}
